import { useSelector } from 'react-redux'
import { selectConfig } from 'services/config/redux/selectors'
import { useAuth } from './useAuth'
import { makeAuthenticatedRequest } from '../utils/api'
import { ApiHook, RequestOptions, BaseApiResponse } from '../types'

export const useApi = (): ApiHook => {
  const auth = useAuth()
  const config = useSelector(selectConfig)
  const brooklynUrl = config.getIn(['data', 'servers', 'brooklyn'])

  const makeRequest = async <T extends BaseApiResponse>(
    endpoint: string,
    options: RequestOptions = {},
  ): Promise<T> => {
    const url = `${brooklynUrl}${endpoint}`
    return makeAuthenticatedRequest<T>(url, auth, options)
  }

  return {
    makeRequest,
    brooklynUrl,
  }
}
